module.exports = __webpack_public_path__ + "img/euroloan@2x.69e254c.png";